export const API_URL = 'https://ub0yw5o4g8.execute-api.eu-central-1.amazonaws.com/export-studio-stage-api-gateway-stage/api/v1/';